export default __webpack_public_path__ + "static/media/20.68cf2278.jpeg";